import { ButtonDanger, ButtonLight } from 'front-end/src/components'
import React from 'react'

import { t, Trans } from '@lingui/macro'

import { ITheme } from '../../../../../types/Series'
import { Modal } from '../../../components/common/modal/Modal'
import { useDeleteThemeModalMutation } from './DeleteThemeModal.codegen'

export interface IDeleteThemeModalProps {
  workspaceId: number
  theme: ITheme<any> | null
  resolve: () => void
  reject: () => void
}

export interface IDeleteThemeModalState {
  isDeleting: boolean
}

export const DeleteThemeModal: React.FC<IDeleteThemeModalProps> = (props) => {
  const [deleteTheme, { loading }] = useDeleteThemeModalMutation()

  const { theme, reject, resolve } = props

  if (theme) {
    if (theme.topics.length) {
      return (
        <Modal
          header={t`Theme cannot be deleted`}
          onHide={reject}
          controls={
            <>
              <ButtonLight onClick={reject}>
                <Trans>OK</Trans>
              </ButtonLight>
            </>
          }
        >
          <p>
            <Trans>
              A theme can only be deleted when there are no drafts or published
              resources in it.
            </Trans>
          </p>
        </Modal>
      )
    } else {
      return (
        <Modal
          header={t`You really want to delete this theme?`}
          onHide={reject}
          controls={
            <>
              <ButtonLight onClick={reject}>
                <Trans>Cancel</Trans>
              </ButtonLight>
              <ButtonDanger
                isLoading={loading}
                onClick={async () => {
                  await deleteTheme({
                    variables: {
                      themeId: theme.id,
                      workspaceId: props.workspaceId
                    }
                  })
                  resolve()
                }}
              >
                <Trans>Delete theme</Trans>
              </ButtonDanger>
            </>
          }
        >
          <p>
            <Trans>
              This will remove access to this theme and all resources in it.
              This action cannot be undone
            </Trans>
          </p>
        </Modal>
      )
    }
  } else {
    return (
      <Modal
        header={t`You really want to delete this theme?`}
        onHide={props.reject}
      >
        <p>
          <Trans>Loading...</Trans>
        </p>
      </Modal>
    )
  }
}
